import React, {Component} from 'react';
import DataChartComponent from './DataChartComponent';

export default class CompetitionCompletionTimeByRfqProcess extends Component {
    render() {
        return (
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <i className="fa fa-angle-right"></i> {window.__js_dashboard.competition_completion_time_by_rfq_process}
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <DataChartComponent data={this.props.data}/>
                </div>
            </div>
        );
    }
}
